export class DateInfo {
    year: string;
    month: string;
    day: string;
    hour: string;
    minute: string;
    seconds: string;
    public constructor(dateStr: string) {
        this.year = dateStr.substring(0, 4);
        this.month = dateStr.substring(4, 6);
        this.day = dateStr.substring(6, 8);
        this.hour = dateStr.substring(8, 10);
        this.minute = dateStr.substring(10, 12);
        this.seconds = dateStr.substring(12, 14);
    }

    get FormatComplete(): string {
        var result =  this.day + "/" + this.month + "/" + this.year + " " + this.hour + ":" + this.minute;
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/entities/dateInfo.ts